import { Component, computed, input, output } from "@angular/core";
import { DateFilterFn } from "@angular/material/datepicker";
import moment from "moment";
import { Moment } from "moment";

@Component({
  selector: "datepicker-input",
  templateUrl: "./datepicker-input.component.html",
  styleUrls: ["./datepicker-input.component.scss"],
  standalone: false,
})
export class DatepickerInputComponent {
  inputDate = input<Date | string>();
  size = input<string>("lg");
  filter = input<(d: Date | null) => boolean | undefined>();
  dateChange = output<Date>();

  constructor() {}

  internalFilter = computed<DateFilterFn<Moment>>(() => (m: Moment | null) => {
    if (!this) return true;
    if (!this.filter()) return true;
    return this.filter()(m?.toDate());
  });

  internalInputDate = computed<Moment>(() => {
    if (!this.inputDate()) return null;
    return moment(this.inputDate());
  });

  change($event: Moment) {
    this.dateChange.emit($event.toDate());
  }
}
